
import {gsap} from 'gsap'
import {ScrollTrigger} from 'gsap/ScrollTrigger.js'

$(document).ready(function() {

  let is_explorer = $('body').hasClass('is-explorer')
  let header = $('.js-open-page-header')

  if (header.length && !is_explorer) {
    setTimeout(function () {

      if (window.innerWidth > 1000) {
        const container = header[0]

        gsap.to(container, {
          opacity: 0,
          ease: "none",
          scrollTrigger: {
            trigger: container,
            start: "top top",
            pin: true,
            pinSpacing: false,
            markers: false,
            scrub: 0.1,
            end: "+=" + 120,
          }
        })
      }

    }, 500)
  }


})
